import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LayoutService, BaseService } from './shared';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './shared';
import { JwtTokenInterceptorService } from './shared/guard/jwt.interceptor';
import { LanguageTranslationModule } from './shared/modules/language-translation/language-translation.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from './shared/shared.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
 
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export function initializeApp(BaseService: BaseService) {
    return (): Promise<any> => BaseService.generateToken();
  }
@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        NgbModule ,
        LanguageTranslationModule,SharedModule,
        BsDropdownModule.forRoot(),
        AppRoutingModule, NgxSpinnerModule.forRoot({ type: 'ball-clip-rotate' }),
        BrowserAnimationsModule, 
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            isolate: true
        }), 

    ],
    declarations: [AppComponent],
    providers: [AuthGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtTokenInterceptorService,
            multi: true,

        }, LayoutService, BaseService,
         {
         provide: APP_INITIALIZER, 
         useFactory: initializeApp,
         deps: [BaseService],
        
      
         multi: true
       },
       {
        provide: APP_INITIALIZER, 
        
        useValue: () =>  new Promise(resolve =>
          setTimeout(resolve, 2000)
        ),
     
        multi: true
      }
       
    
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
